const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

const addDays = (dateObj, numDays) => {
    dateObj.setDate(dateObj.getDate() + numDays);
    return dateObj; 
}

const getDatesInRange = (startDate, endDate) => {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    const date = new Date(startDate.getTime());
  
    const dates = [];
  
    while (date <= endDate) {
      dates.push(formatDate(new Date(date)));
      date.setDate(date.getDate() + 1);
    }
    
    return dates;
}

const generateDatesBeetweenPeriod = (startDate, perdiod) => {

    return {
        start : formatDate(addDays(new Date(startDate), perdiod)),
        end : formatDate(addDays(new Date(startDate), - 1))
    }
}



export { formatDate, addDays, getDatesInRange, generateDatesBeetweenPeriod };